import gql from 'graphql-tag'

export default (templateId, { name, organizationId, country, comercialBase, contractType, comercialCategoryId, contractCategories, templateUrl }) => {
	return {
		mutation: gql`
			mutation($template_id: bigint!, $name: String!, $organization_id: bigint!, $country: String!, $comercial_base: bigint!, $contract_type: bigint!, $comercial_category_id: bigint!, $contract_categories: _int8!, $template_url: String!) {
				update_pdf_templates_by_pk(pk_columns: { id: $template_id }, _set: { name: $name, organization_id: $organization_id, country: $country, comercial_base: $comercial_base, contract_type: $contract_type, comercial_category_id: $comercial_category_id, contract_categories: $contract_categories, template_url: $template_url }) {
					id
				}
			}
		`,
		variables: {
			template_id: parseInt(templateId),
			name,
			organization_id: organizationId,
			country,
			comercial_base: comercialBase,
			contract_type: contractType,
			comercial_category_id: comercialCategoryId,
			contract_categories: `{${(contractCategories || []).map(item => parseInt(item.id)).join(',')}}`,
			template_url: templateUrl
		}
	}
}
